/////////////// قدیمی ولی جواب داده است!
// api.js
import axios from 'axios';
import { BASE_URL } from '../constant-value';

const api = axios.create({
    baseURL: `${BASE_URL}`,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;


// ///////////////////////////////
// import axios from "axios";
// import { BASE_URL } from "../constant-value";
// // اگر toast داری
// // import { toast } from "react-toastify";

// const api = axios.create({
//   baseURL: BASE_URL,
//   timeout: 15000, // 15 ثانیه
// });

// /* =======================
//    Request Interceptor
// ======================= */
// api.interceptors.request.use(
//   (config) => {
//     // 1️⃣ چک آفلاین قبل از ارسال
//     if (!navigator.onLine) {
//       return Promise.reject({
//         message: "OFFLINE",
//       });
//     }

//     // 2️⃣ اضافه کردن توکن
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// /* =======================
//    Response Interceptor
// ======================= */
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // ❌ اینترنت قطع
//     if (error.message === "OFFLINE") {
//       // toast.error("اتصال اینترنت قطع شده است");
//       console.error("OFFLINE");
//       return Promise.reject(error);
//     }

//     // ❌ خطای شبکه (سرور در دسترس نیست)
//     if (error.code === "ERR_NETWORK") {
//       // toast.error("ارتباط با سرور برقرار نشد");
//       console.error("NETWORK ERROR");
//       return Promise.reject(error);
//     }

//     // ❌ timeout
//     if (error.code === "ECONNABORTED") {
//       // toast.error("درخواست بیش از حد طول کشید");
//       console.error("TIMEOUT");
//       return Promise.reject(error);
//     }

//     // ❌ پاسخ از سرور داریم
//     if (error.response) {
//       const { status } = error.response;

//       switch (status) {
//         case 401:
//           console.error("UNAUTHORIZED");
//           localStorage.removeItem("token");
//           // window.location.href = "/login";
//           break;

//         case 403:
//           console.error("FORBIDDEN");
//           break;

//         case 500:
//           console.error("SERVER ERROR");
//           break;

//         default:
//           console.error("API ERROR", status);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default api;
